import "./index.css";
import { lazy, Suspense, useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Navigate, useLocation } from "react-router-dom";
import { Navbar } from "./components/sections/Navbar";
import { Hero } from "./components/sections/Hero";
import { About } from "./components/sections/About";
import { Projects } from "./components/sections/Projects";
import { Certifications } from "./components/sections/Certifications";
import { Contact } from "./components/sections/Contact";
import { Footer } from "./components/sections/Footer";
import { LoadingScreen } from "./components/ui/LoadingScreen";

const CMSRouter = lazy(() => import("./cms/CMSRouter"));

function MainWebsite() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isLoading) return;
    document.documentElement.classList.add("site-framed");
    return () => document.documentElement.classList.remove("site-framed");
  }, [isLoading]);

  return (
    <>
      <AnimatePresence mode="wait">
        {isLoading && <LoadingScreen onComplete={() => setIsLoading(false)} />}
      </AnimatePresence>

      {!isLoading && (
        <div className="apple-site min-h-screen transition-colors duration-300 selection:bg-[#525252]/25">
          <div className="site-frame" aria-hidden="true" />
          <Navbar />
          <main>
            <Hero />
            <About />
            <Projects />
            <Certifications />
            <Contact />
          </main>
          <Footer />
        </div>
      )}
    </>
  );
}

export function App() {
  const location = useLocation();
  const isCMS = location.pathname.startsWith("/cms");

  if (location.pathname === "/login") {
    return <Navigate to="/cms/login" replace />;
  }

  if (isCMS) {
    return (
      <Suspense
        fallback={
          <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
            Loading CMS…
          </div>
        }
      >
        <CMSRouter />
      </Suspense>
    );
  }

  return <MainWebsite />;
}

export default App;
